module.exports = __webpack_public_path__ + "static/media/quiver.f28e7c1f.png";